
export class AppGlobalTranslationDictionary {


    public CountryData: any = [
        {
            id: 2, text: $localize`Germany`,
            states: [
                { id: 1, text: $localize`Baden-Württemberg` },
                { id: 2, text: $localize`Bayern` },
                { id: 3, text: $localize`Berlin` },
                { id: 4, text: $localize`Brandenburg` },
                { id: 5, text: $localize`Bremen` },
                { id: 6, text: $localize`Hamburg` },
                { id: 7, text: $localize`Hessen` },
                { id: 8, text: $localize`Lower Saxony` },
                { id: 9, text: $localize`Mecklenburg-Vorpommern` },
                { id: 10, text: $localize`North Rhine-Westphalia` },
                { id: 11, text: $localize`Rhineland-Palatinate` },
                { id: 12, text: $localize`Saarland` },
                { id: 13, text: $localize`Saxony` },
                { id: 14, text: $localize`Saxony-Anhalt` },
                { id: 15, text: $localize`Schleswig-Holstein` },
                { id: 16, text: $localize`Thuringia` }
            ]
        },
        {
            id: 3, text: $localize`Austria`,
            states: [
                { id: 17, text: $localize`Burgenland` },
                { id: 18, text: $localize`Carinthia` },
                { id: 19, text: $localize`Lower Austria` },
                { id: 20, text: $localize`Salzburg` },
                { id: 21, text: $localize`Styria` },
                { id: 22, text: $localize`Tyrol` },
                { id: 23, text: $localize`Upper Austria` },
                { id: 24, text: $localize`Vienna` },
                { id: 25, text: $localize`Vorarlberg` },
            ]
        },
        {
            id: 4, text: $localize`Switzerland`,
            states: [
                { id: 26, text: $localize`Zurich` },
                { id: 27, text: $localize`Aargau` },
                { id: 28, text: $localize`Appenzell Ausserrhoden` },
                { id: 29, text: $localize`Appenzell Innerrhoden` },
                { id: 30, text: $localize`Basel-City` },
                { id: 31, text: $localize`Basel-Country` },
                { id: 32, text: $localize`Bern` },
                { id: 33, text: $localize`Freiburg` },
                { id: 34, text: $localize`Geneva` },
                { id: 35, text: $localize`Glarus` },
                { id: 36, text: $localize`Graubünden` },
                { id: 37, text: $localize`Jura` },
                { id: 38, text: $localize`Lucerne` },
                { id: 39, text: $localize`Neuchâtel` },
                { id: 40, text: $localize`Nidwalden` },
                { id: 41, text: $localize`Obwalden` },
                { id: 42, text: $localize`Schaffhausen` },
                { id: 43, text: $localize`Schwyz` },
                { id: 44, text: $localize`Solothurn` },
                { id: 45, text: $localize`St. Gallen` },
                { id: 46, text: $localize`Tessin` },
                { id: 47, text: $localize`Thurgovia` },
                { id: 48, text: $localize`Uri` },
                { id: 49, text: $localize`Valais` },
                { id: 50, text: $localize`Vaud` },
                { id: 51, text: $localize`Zug` },
            ]
        },
        {
            id: 5, text: $localize`Luxembourg`,
            states: [
                { id: 52, text: $localize`Clervaux` },
                { id: 53, text: $localize`Wiltz` },
                { id: 54, text: $localize`Vianden` },
                { id: 55, text: $localize`Redange` },
                { id: 56, text: $localize`Diekirch` },
                { id: 57, text: $localize`Mersch` },
                { id: 58, text: $localize`Echternach` },
                { id: 59, text: $localize`Capellen` },
                { id: 60, text: $localize`Luxembourg` },
                { id: 61, text: $localize`Grevenmacher` },
                { id: 62, text: $localize`Esch-sur-Alzette` },
                { id: 63, text: $localize`Remich` },
            ]
        },
        {
            id: 6, text: $localize`Poland`,
            states: [
                { id: 64, text: $localize`Poland` },

            ]
        },
        /* {
            id: 7, text: $localize`Turkey`,
            states: [
                { id: --, text: $localize`` },

            ]
        } */
    ];

    public CountryData_old: any = [
        {
            id: 2, value: 'Deutschland', text: $localize`Germany`,
            states: [
                { id: 1, value: 'Baden-Württemberg', text: $localize`Baden-Württemberg` },
                { id: 2, value: 'Bayern', text: $localize`Bayern` },
                { id: 3, value: 'Berlin', text: $localize`Berlin` },
                { id: 4, value: 'Brandenburg', text: $localize`Brandenburg` },
                { id: 5, value: 'Bremen', text: $localize`Bremen` },
                { id: 6, value: 'Hamburg', text: $localize`Hamburg` },
                { id: 7, value: 'Hessen', text: $localize`Hessen` },
                { id: 8, value: 'Niedersachsen', text: $localize`Lower Saxony` },
                { id: 9, value: 'Mecklenburg-Vorpommern', text: $localize`Mecklenburg-Vorpommern` },
                { id: 10, value: 'Nordrhein-Westpfalen', text: $localize`North Rhine-Westphalia` },
                { id: 11, value: 'Rheinland-Pfalz', text: $localize`Rhineland-Palatinate` },
                { id: 12, value: 'Saarland', text: $localize`Saarland` },
                { id: 13, value: 'Sachsen', text: $localize`Saxony` },
                { id: 14, value: 'Sachsen-Anhalt', text: $localize`Saxony-Anhalt` },
                { id: 15, value: 'Schleswig-Holstein', text: $localize`Schleswig-Holstein` },
                { id: 16, value: 'Thüringen', text: $localize`Thuringia` }
            ]
        },
        {
            id: 3, value: 'Österreich', text: $localize`Austria`,
            states: [
                { id: 17, value: 'Burgenland', text: $localize`Burgenland` },
                { id: 18, value: 'Carinthia', text: $localize`Carinthia` },
                {
                    id: 19, value: 'Niederösterreich', text: $localize`Lower Austria`
                },
                { id: 20, value: 'Salzburg', text: $localize`Salzburg` },
                { id: 21, value: 'Steiermark', text: $localize`Styria` },
                { id: 22, value: 'Tirol', text: $localize`Tyrol` },
                { id: 23, value: 'Oberösterreich', text: $localize`Upper Austria` },
                { id: 24, value: 'Wien', text: $localize`Vienna` },
                { id: 25, value: 'Vorarlberg', text: $localize`Vorarlberg` },
            ]
        },
        {
            id: 4, value: 'Schweiz', text: $localize`Switzerland`,
            states: [
                { id: 26, value: 'Zürich', text: $localize`Zurich` },
                { id: 27, value: 'Aargau', text: $localize`Aargau` },
                { id: 28, value: 'Appenzell Ausserrhoden', text: $localize`Appenzell Ausserrhoden` },
                { id: 29, value: 'Appenzell Innerrhoden', text: $localize`Appenzell Innerrhoden` },
                { id: 30, value: 'Basel-City', text: $localize`Basel-City` },
                { id: 31, value: 'Basel-Landschaft', text: $localize`Basel-Country` },
                { id: 32, value: 'Bern', text: $localize`Bern` },
                { id: 33, value: 'Freiburg', text: $localize`Freiburg` },
                { id: 34, value: 'Genf', text: $localize`Geneva` },
                { id: 35, value: 'Glarus', text: $localize`Glarus` },
                { id: 36, value: 'Graubünden', text: $localize`Graubünden` },
                { id: 37, value: 'Jura', text: $localize`Jura` },
                { id: 38, value: 'Lucerne', text: $localize`Lucerne` },
                { id: 39, value: 'Neuchâtel', text: $localize`Neuchâtel` },
                { id: 40, value: 'Nidwalden', text: $localize`Nidwalden` },
                { id: 41, value: 'Obwalden', text: $localize`Obwalden` },
                { id: 42, value: 'Schaffhausen', text: $localize`Schaffhausen` },
                { id: 43, value: 'Schwyz', text: $localize`Schwyz` },
                { id: 44, value: 'Solothurn', text: $localize`Solothurn` },
                { id: 45, value: 'St. Gallen', text: $localize`St. Gallen` },
                { id: 46, value: 'Tessin', text: $localize`Tessin` },
                { id: 47, value: 'Thurgovia', text: $localize`Thurgovia` },
                { id: 48, value: 'Uri', text: $localize`Uri` },
                { id: 49, value: 'Valais', text: $localize`Valais` },
                { id: 50, value: 'Vaud', text: $localize`Vaud` },
                { id: 51, value: 'Zug', text: $localize`Zug` },
            ]
        },
        {
            id: 5, value: 'Luxemburg', text: $localize`Luxembourg`,
            states: [
                { id: 52, value: 'Clervaux', text: $localize`Clervaux` },
                { id: 53, value: 'Wiltz', text: $localize`Wiltz` },
                { id: 54, value: 'Vianden', text: $localize`Vianden` },
                { id: 55, value: 'Redange', text: $localize`Redange` },
                { id: 56, value: 'Diekirch', text: $localize`Diekirch` },
                { id: 57, value: 'Mersch', text: $localize`Mersch` },
                { id: 58, value: 'Echternach', text: $localize`Echternach` },
                { id: 59, value: 'Capellen', text: $localize`Capellen` },
                { id: 60, value: 'Luxembourg', text: $localize`Luxembourg` },
                { id: 61, value: 'Grevenmacher', text: $localize`Grevenmacher` },
                { id: 62, value: 'Esch-sur-Alzette', text: $localize`Esch-sur-Alzette` },
                { id: 63, value: 'Remich', text: $localize`Remich` },
            ]
        },
        /*
        {
            id: 6, value: 'Polen', text: $localize`Poland`,
            states: [
                { id: 64, value: '', text: $localize`` },

            ]
        },
        */
        /* {
            id: 7, text: $localize`Turkey`,
            states: [
                { id: --, text: $localize`` },

            ]
        } */
    ];

    public ProjectTypeData: any = [
        { id: 1, text: $localize`Roof` },
        { id: 2, text: $localize`Floating` },
        { id: 3, text: $localize`Open Space` },
        { id: 4, text: $localize`Open Space (Structure)` },
        { id: 5, text: $localize`Open Space (Landfill, Structure)` },
        { id: 6, text: $localize`Open Space (Conversion Area)` },
        { id: 7, text: $localize`Open Space (Military)` },
        { id: 8, text: $localize`Open Space (Legal Basis)` },
        { id: 9, text: $localize`Building (Roof)` },
        { id: 10, text: $localize`Special Project` },
    ];

   
    

}